<aside [class]="'fixed left-0 z-40 lg:pb-12 transition-transform duration-300 w-64 ' + height() + ' ' + (isOpen() ? 'translate-x-0' : '-translate-x-full lg:-translate-x-full')" aria-label="Sidebar">
  <div class="h-full px-3 py-4 overflow-y-auto bg-neutral-primary-soft border-e border-default">
    <ng-content />
  </div>
</aside>

@if (isOpen()) {
  <div class="fixed inset-0 z-30 bg-gray-900/50 lg:hidden" (click)="onBackdropClick()">
  </div>
}
